module.exports = __webpack_public_path__ + "1d8b73ebf1e5a91ba2eb39fea10bffe4.svg";